import { UsageData } from "./api";
import { LangCodeType } from "./language";
import { OnboardingMetadata } from "../features/auth/types/onboarding";

export interface IClerkPublicMetaData extends UsageData {
  stripeCustomerId: string;
  created_date: string;
  is_premium: boolean;
  settings: {
    lang?: LangCodeType;
    library_id?: string;
    has_seen_library_modal?: boolean;
  };
  hasUsedStudentTrial?: boolean;
  is_incognito_mode_active?: boolean;
  is_research_hub_banner_hidden?: boolean;
  is_thread_banner_hidden?: boolean;
  is_deep_search_banner_hidden?: boolean;
  is_table_view_new_tag_hidden?: boolean;
  email_settings?: {
    deep_search_notification_enabled?: boolean;
    primary_notification_email?: string;
    // Add more notification types here as they are implemented
  };
  onboarding_data?: OnboardingMetadata["onboarding_data"];
  onboarding_viewed?: boolean;
}

export function convertUserPublicMetadata(publicMetadata: {
  [k: string]: unknown;
}): IClerkPublicMetaData {
  let userPublicMetadata: IClerkPublicMetaData = {
    stripeCustomerId: publicMetadata.stripeCustomerId as string,
    created_date: publicMetadata.created_date as string,
    last_reset_date: publicMetadata.last_reset_date as string,
    used_study_paper_ids: publicMetadata.used_study_paper_ids as string[],
    used_quick_search_queries:
      publicMetadata.used_quick_search_queries as string[],
    used_pro_search_queries: publicMetadata.used_pro_search_queries as string[],
    used_deep_search_queries:
      publicMetadata.used_deep_search_queries as string[],
    ask_paper_messages_per_paper_count:
      publicMetadata.ask_paper_messages_per_paper_count as {
        [key: string]: number;
      },
    used_consensus_snapshot_queries:
      publicMetadata.used_consensus_snapshot_queries as string[],
    is_premium: publicMetadata.is_premium as boolean,
    settings: publicMetadata.settings as {
      lang?: LangCodeType;
      library_id?: string;
      has_seen_library_modal?: boolean;
    },
    hasUsedStudentTrial:
      (publicMetadata.hasUsedStudentTrial as boolean) || false, // Initialize to false if undefined,
    is_incognito_mode_active:
      publicMetadata.is_incognito_mode_active as boolean,
    is_research_hub_banner_hidden:
      publicMetadata.is_research_hub_banner_hidden as boolean,
    is_thread_banner_hidden: publicMetadata.is_thread_banner_hidden as boolean,
    is_deep_search_banner_hidden:
      publicMetadata.is_deep_search_banner_hidden as boolean,
    is_table_view_new_tag_hidden:
      publicMetadata.is_table_view_new_tag_hidden as boolean,
    email_settings: publicMetadata.email_settings as {
      deep_search_notification_enabled?: boolean;
      primary_notification_email?: string;
    },
    onboarding_data:
      publicMetadata.onboarding_data as OnboardingMetadata["onboarding_data"],
    onboarding_viewed: publicMetadata.onboarding_viewed as boolean,
    bonus_deep_search_credits:
      (publicMetadata.bonus_deep_search_credits as number) || 0,
  };

  return userPublicMetadata;
}

export interface IClerkOrganizationPublicMetadata {
  accepted_into_api_beta: boolean;
}

export function convertOrganizationPublicMetadata(publicMetadata: {
  [k: string]: unknown;
}): IClerkOrganizationPublicMetadata {
  let orgPublicMetadata: IClerkOrganizationPublicMetadata = {
    accepted_into_api_beta: publicMetadata.accepted_into_api_beta as boolean,
  };
  return orgPublicMetadata;
}
